// Real data scraped from www.membratek.com

// Helper to upscale wix CDN images by replacing fill width/height
const W = (url, w = 1200, h = 800) =>
  url.replace(
    /\/v1\/fill\/w_\d+,h_\d+[^/]*\//,
    `/v1/fill/w_${w},h_${h},al_c,q_85,enc_avif,quality_auto/`
  );

export const navLinks = [
  { label: 'Ana sayfa', to: '/', id: 'home' },
  { label: 'Projeler', to: '/projeler', id: 'projeler' },
  { label: 'Urunler', to: '/urunler', id: 'urunler' },
  { label: 'Iletisim', to: '/iletisim', id: 'iletisim' },
];

export const stats = [
  { value: '15+', label: 'YILLIK DENEYIM' },
  { value: '500+', label: 'TAMAMLANAN PROJE' },
  { value: '25+', label: 'SEHIRDE HIZMET' },
  { value: 'ISO 9001', label: 'KALITE BELGESI' },
];

// Hero & about — real Membratek imagery
export const heroImage =
  'https://static.wixstatic.com/media/eeca94_6de20638dee54508bae0914144fc733e~mv2.jpg/v1/fill/w_1920,h_1200,fp_0.53_0.57,q_90,enc_avif,quality_auto/eeca94_6de20638dee54508bae0914144fc733e~mv2.jpg';

export const aboutImage =
  'https://static.wixstatic.com/media/eeca94_4ca294f57206488ea7c830624b54a171~mv2.jpeg/v1/fill/w_1100,h_1400,al_c,q_85,enc_avif,quality_auto/WhatsApp-Image-2020-07-23-at-17_17_45-1024x575.jpeg';

export const products = [
  {
    slug: 'asmagerme-sistemleri',
    title: 'Asmagerme Sistemleri',
    description: 'Egrisel tasarimlarla estetik ve dayanikliligi bir araya getiren asma germe cozumleri.',
    longDescription:
      'Asma germe sistemleri, esnek membran malzemelerin celik konstruksiyon ile birlikte kullanilmasiyla olusturulan modern mimari yapilardir. Estetik gorunum, hafiflik ve dayaniklilik bir araya gelir; cesitli aciklik ve formlar icin idealdir.',
    image:
      'https://static.wixstatic.com/media/eeca94_6de20638dee54508bae0914144fc733e~mv2.jpg/v1/fill/w_1100,h_800,fp_0.62_0.55,q_85,enc_avif,quality_auto/eeca94_6de20638dee54508bae0914144fc733e~mv2.jpg',
    icon: 'Triangle',
    features: ['UV dayanimi', 'Yangina dayanikli kumas', '25+ yil omur', 'Ozel tasarim'],
    relatedProjects: [
      'marmaris-sahil-acilir-kapanir-asma-germe',
      'sancaktepe-cocuk-park',
      'adana-imamoglu-millet-bahcesi',
      'new-zahko',
      'toskana-vadisi',
      'kayseri-pazaryeri',
    ],
  },
  {
    slug: 'endustriyel-depo-cadirlari',
    title: 'Endustriyel Depo Cadirlari',
    description: 'Genis aciklikli, kolay monte edilebilir depolama alanlari.',
    longDescription:
      'Endustriyel uretim, lojistik ve depolama ihtiyaclari icin tasarlanmis genis aciklikli celik konstruksiyonlu cadirlar; hizli montaj ve uzun omur sunar.',
    image:
      'https://static.wixstatic.com/media/eeca94_e3655c78851e4f2fa319de1103d7a29b~mv2.jpg/v1/fill/w_1100,h_800,al_c,q_85,enc_avif,quality_auto/eeca94_e3655c78851e4f2fa319de1103d7a29b~mv2.jpg',
    icon: 'Warehouse',
    features: ['Genis aciklik', 'Hizli montaj', 'Tasinabilir', 'Yuksek hacim'],
    relatedProjects: [
      'nema-winkelmann-fabrika',
      'coante-mermer-fabrika-deposu',
      'cankiri-alpin-corap-fabrikasi',
      'gebze-pelzem-pimsa',
      'cankiri-alpin-corap',
    ],
  },
  {
    slug: 'celik-yapilar',
    title: 'Celik Yapilar',
    description: 'Yuksek mukavemetli celik konstruksiyon sistemleri.',
    longDescription:
      'Modern muhendislik standartlarinda tasarlanan celik konstruksiyon sistemleri, ticari ve endustriyel yapilar icin yuksek dayaniklilik saglar.',
    image:
      'https://static.wixstatic.com/media/eeca94_dff168e06a6b49eb9bf314b0edfc07e7~mv2.jpg/v1/fill/w_1100,h_800,al_c,q_85,enc_avif,quality_auto/eeca94_dff168e06a6b49eb9bf314b0edfc07e7~mv2.jpg',
    icon: 'Settings',
    features: ['Yuksek dayaniklilik', 'ISO standartlari', 'Modular tasarim', 'Galvaniz koruma'],
    relatedProjects: [
      'nema-winkelmann-fabrika',
      'gebze-pelzem-pimsa',
      'canakkale-koprusu',
      'cankiri-alpin-corap-fabrikasi',
    ],
  },
  {
    slug: 'kiralik-dome-cadirlari',
    title: 'Kiralik Dome Cadirlari',
    description: 'Ozel etkinlikleriniz icin kiralik kubbe cadir cozumleri.',
    longDescription:
      'Dugun, konser, fuar, kurumsal etkinlik gibi ozel organizasyonlar icin gorkemli kubbe cadirlari; profesyonel ekibimizle kurulum ve sokum.',
    image:
      'https://static.wixstatic.com/media/eeca94_68be0f4683dd49ea86bd87e60d4df59f~mv2.jpg/v1/fill/w_1100,h_800,al_c,q_85,enc_avif,quality_auto/eeca94_68be0f4683dd49ea86bd87e60d4df59f~mv2.jpg',
    icon: 'CircleDot',
    features: ['Esnek kiralama', 'Aydinlatma sistemi', 'Ic dekor', 'Kurulum dahil'],
    relatedProjects: [
      'rize-ardesen-cift-kubbe',
      'turkiyenin-ilk-30m-planateryumu',
      'izmit-ceyyil-mega-ters-semsiyesi',
    ],
  },
  {
    slug: 'ucak-hangarlari',
    title: 'Ucak Hangarlari',
    description: 'Buyuk aciklikli, guvenli ucak barindirma yapilari.',
    longDescription:
      'Sivil ve askeri havacilik icin tasarlanmis genis aciklikli hangarlar; hava sartlarina dayanikli, ozel olcum ve muhendislik.',
    image:
      'https://static.wixstatic.com/media/eeca94_5bbcbfc5327d4f46a987740c0b06835d~mv2.jpg/v1/fill/w_1100,h_800,al_c,q_85,enc_avif,quality_auto/eeca94_5bbcbfc5327d4f46a987740c0b06835d~mv2.jpg',
    icon: 'Plane',
    features: ['Genis aciklik', 'Yangin direnci', 'Havalandirma', 'Ozel kapi sistemleri'],
    relatedProjects: [
      'nema-winkelmann-fabrika',
      'coante-mermer-fabrika-deposu',
    ],
  },
  {
    slug: 'halisaha-cadirlari',
    title: 'Halisaha Cadirlari',
    description: 'Yil boyu kullanima uygun spor tesisi kapama sistemleri.',
    longDescription:
      'Halisaha, tenis kortu, basketbol sahasi gibi spor tesisleri icin yil boyu kullanim saglayan kapama cadir sistemleri.',
    image:
      'https://static.wixstatic.com/media/eeca94_2ae5d6ee82b5463ca6849b4b0dcb0174~mv2.jpg/v1/fill/w_1100,h_800,al_c,q_85,enc_avif,quality_auto/eeca94_2ae5d6ee82b5463ca6849b4b0dcb0174~mv2.jpg',
    icon: 'CircleDashed',
    features: ['UV korumali', 'Isi yalitimi', 'Hava sirkulasyonu', 'Genis aciklik'],
    relatedProjects: [
      'fethiye-basketbol-sahasi',
      'erzurum-uzundere-gures-sahasi',
      'erzincan-elite-koleji-okul',
      'erzincan-elite-koleji-2',
    ],
  },
  {
    slug: 'sisme-cadirlari',
    title: 'Sisme Cadirlari',
    description: 'Hizli kurulum, pratik tasinabilir sisme cadir sistemleri.',
    longDescription:
      'Reklam, fuar, etkinlik ve sahra uygulamalari icin hizli sisirilip toplanan; tasinabilir pratik cozumler.',
    image:
      'https://static.wixstatic.com/media/eeca94_8e7d2b84f26e48b8b71cafa395ecc39f~mv2.png/v1/fill/w_1100,h_800,al_c,q_85,enc_avif,quality_auto/eeca94_8e7d2b84f26e48b8b71cafa395ecc39f~mv2.png',
    icon: 'Wind',
    features: ['Hizli kurulum', 'Hafif', 'Tasinabilir', 'Ozel renk'],
    relatedProjects: [],
  },
  {
    slug: 'santiye-cadirlari',
    title: 'Santiye Cadirlari',
    description: 'Santiye alanlariniz icin dayanikli gecici yapi cozumleri.',
    longDescription:
      'Insaat sahalari icin gecici barinma, ofis, depo ve yemekhane ihtiyaclarini karsilayan dayanikli santiye cadiri sistemleri.',
    image:
      'https://static.wixstatic.com/media/eeca94_1f3b63d21fa945508f383219e6b4ca22~mv2.jpg/v1/fill/w_1100,h_800,al_c,q_85,enc_avif,quality_auto/eeca94_1f3b63d21fa945508f383219e6b4ca22~mv2.jpg',
    icon: 'HardHat',
    features: ['Hava kosullarina dayanim', 'Hizli montaj', 'Modular', 'Demonte edilebilir'],
    relatedProjects: [
      'gebze-otopark',
      'ordu-otopark',
      'ankara-golf-arabasi-park-alani',
      'kazakistan-otopark',
    ],
  },
];

export const whyUs = [
  {
    number: '01',
    title: 'Profesyonel Ekip',
    description: 'Alaninda uzman, deneyimli muhendis ve teknik ekibimizle her asamada yaninizdayiz.',
    icon: 'Users',
  },
  {
    number: '02',
    title: 'Uygun Maliyetli',
    description: 'En uygun fiyatlandirma ile en yuksek kaliteyi sunuyoruz.',
    icon: 'TrendingDown',
  },
  {
    number: '03',
    title: 'Kalite',
    description: 'ISO 9001 belgeli, uluslararasi standartlarda uretim ve montaj.',
    icon: 'Award',
  },
  {
    number: '04',
    title: 'Hizli Montaj',
    description: 'Profesyonel ekipman ve deneyimli kadro ile zamandan tasarruf.',
    icon: 'Clock',
  },
];

// Real projects from www.membratek.com — sourced from official CSV (58 projects)
const _rawProjects = [
{
    title: 'New Zahko',
    slug: 'new-zahko',
    location: 'Irak',
    category: 'Park',
    image: 'https://static.wixstatic.com/media/eeca94_fa341a41af304b838b972c20265fd11e~mv2.jpg/v1/fill/w_1100,h_750,al_c,q_85,enc_avif,quality_auto/957fc15c-7e15-4308-947f-c42d58a68f02_edited.jpg',
    year: 2024,
    material: 'PVC Membran',
    form: 'Yelken',
    areaM2: 10000,
    application: 'Park-Beyaz Köy Projesi',
  },
  {
    title: 'Kırklareli Atatürk Stadyumu',
    slug: 'kirklareli-ataturk-stadyumu',
    location: 'Kirlareli',
    category: 'Stadyum',
    image: 'https://static.wixstatic.com/media/eeca94_4ca294f57206488ea7c830624b54a171~mv2.jpeg/v1/fill/w_1100,h_750,al_c,q_85,enc_avif,quality_auto/WhatsApp-Image-2020-07-23-at-17.17.45-1024x575.jpeg',
    year: 2020,
    material: 'PVC Membran',
    form: 'Kemeli',
    areaM2: 8000,
    application: 'Stadyum Kapama',
  },
  {
    title: 'Mersin Gençlik Kampları',
    slug: 'mersin-genclik-kamplari',
    location: 'Mersin',
    category: 'Park',
    image: 'https://static.wixstatic.com/media/eeca94_07e7702799294ad4aec17870c5099623~mv2.jpg/v1/fill/w_1100,h_750,al_c,q_85,enc_avif,quality_auto/DJI_0034-1024x576.jpg',
    year: 2021,
    material: 'PVC Membran',
    form: 'Yelken',
    areaM2: 8000,
    application: 'Park ve Rekreasyon',
  },
  {
    title: 'Uşak kışladağ Altınmadeni',
    slug: 'usak-kisladag-altinmadeni',
    location: 'Uşak',
    category: 'Fabrika',
    image: 'https://static.wixstatic.com/media/eeca94_177f7af99ec94e8c80a302468df8604e~mv2.jpg/v1/fill/w_1100,h_750,al_c,q_85,enc_avif,quality_auto/IMG-20241116-WA0345.jpg',
    year: 2013,
    material: 'PVC Membran',
    form: 'Depo Çadır',
    areaM2: 7500,
    application: 'Altımadeni',
  },
  {
    title: 'Gebze Pelzem Pimsa',
    slug: 'gebze-pelzem-pimsa',
    location: 'Gebze',
    category: 'Fabrika',
    image: 'https://static.wixstatic.com/media/eeca94_340d54919ecf4e53b90126ae70737ed4~mv2.jpeg/v1/fill/w_1100,h_750,al_c,q_85,enc_avif,quality_auto/plzem-pisma-1024x578.jpeg',
    year: 2021,
    material: 'PVC Membran',
    form: 'Düz Kapma',
    areaM2: 6000,
    application: 'Depo Sanayi Alanı',
  },
  {
    title: 'Pendik Gülübağlar Pazar Yeri',
    slug: 'pendik-gulubaglar-pazar-yeri',
    location: 'Pendik',
    category: 'Pazar Yeri',
    image: 'https://static.wixstatic.com/media/eeca94_4b697da3f02c472aa21543e5f9b249a1~mv2.jpeg/v1/fill/w_1100,h_750,al_c,q_85,enc_avif,quality_auto/1.jpeg',
    year: 2022,
    material: 'PVC Membran',
    form: 'Kemerli',
    areaM2: 5000,
    application: 'Pazar Yeri',
  },
  {
    title: 'Kırıkkale Belediyesi Pazar Yeri',
    slug: 'kirikkale-belediyesi-pazar-yeri',
    location: 'kırıkkale',
    category: 'Pazar Yeri',
    image: 'https://static.wixstatic.com/media/eeca94_49fe6a579a454ad79adf18ee057c6f9c~mv2.png/v1/fill/w_1100,h_750,al_c,q_85,enc_avif,quality_auto/1.png',
    year: 2021,
    material: 'PVC Membran',
    form: 'Ters Şemsiye',
    areaM2: 5000,
    application: 'Pazar yeri',
  },
  {
    title: 'Kırşehir Stadyumu',
    slug: 'kirsehir-stadyumu',
    location: 'Kırşehir',
    category: 'Stadyum',
    image: 'https://static.wixstatic.com/media/eeca94_aa160ebcc8c648ce8ce5e6d47bb739d3~mv2.png/v1/fill/w_1100,h_750,al_c,q_85,enc_avif,quality_auto/Resim1-4.png',
    year: 2017,
    material: 'PVC Membran',
    form: 'Stadyum Kapama',
    areaM2: 4600,
    application: 'Stadyum Kapama',
  },
  {
    title: 'Zonguldak Devrek',
    slug: 'zonguldak-devrek',
    location: 'Zonguldak',
    category: 'Park',
    image: 'https://static.wixstatic.com/media/eeca94_a7199d4850b84ee8b51e0afcbcd26aab~mv2.jpg/v1/fill/w_1100,h_750,al_c,q_85,enc_avif,quality_auto/zonguldakdevrek54545-1024x575.jpg',
    year: 2018,
    material: 'PVC Membran',
    form: 'Kubbe',
    areaM2: 4000,
    application: 'Park ve Rekreasyon',
  },
  {
    title: 'Rize Ardeşen Çift Kubbe',
    slug: 'rize-ardesen-cift-kubbe',
    location: 'Rize',
    category: 'Park',
    image: 'https://static.wixstatic.com/media/eeca94_e2b7c75a8a1a44d7857fb176844f0b08~mv2.jpg/v1/fill/w_1100,h_750,al_c,q_85,enc_avif,quality_auto/rizeardesen478-1-1024x578.jpg',
    year: 2018,
    material: 'PVC Membran',
    form: 'Kubbe',
    areaM2: 4000,
    application: 'Park ve Rekreasyon',
  },
  {
    title: 'Kazakistan Otopark',
    slug: 'kazakistan-otopark',
    location: 'Kazakistan',
    category: 'Otopark',
    image: 'https://static.wixstatic.com/media/eeca94_b9aac49aab614c1c9601cab02fa69af5~mv2.jpg/v1/fill/w_1100,h_750,al_c,q_85,enc_avif,quality_auto/ana-resim-kazakistan.jpg',
    year: 2017,
    material: 'PVC Membran',
    form: 'Düz Kapma',
    areaM2: 3800,
    application: 'Otopark Kapama',
  },
  {
    title: 'Aksaray Üniversitesi 2.Proje',
    slug: 'aksaray-universitesi-2-proje',
    location: 'Aksaray',
    category: 'Egitim',
    image: 'https://static.wixstatic.com/media/eeca94_eac4241f6894411fac8e247c834deae6~mv2.jpeg/v1/fill/w_1100,h_750,al_c,q_85,enc_avif,quality_auto/WhatsApp-Image-2020-07-11-at-18.46.22-1-1024x576.jpeg',
    year: 2020,
    material: 'PVC Membran',
    form: 'Kubbe',
    areaM2: 3200,
    application: 'Ünversite Parkı',
  },
  {
    title: 'Sivas Resturant',
    slug: 'sivas-resturant',
    location: 'Sivas',
    category: 'Restoran',
    image: 'https://static.wixstatic.com/media/eeca94_3d1cbb6eec1d487f8de24620f64aa817~mv2.jpg/v1/fill/w_1100,h_750,al_c,q_85,enc_avif,quality_auto/IMG-20241016-WA0030.jpg',
    year: 2023,
    material: 'Siyah PVC',
    form: 'Piramet',
    areaM2: 3000,
    application: 'Resturant',
  },
  {
    title: 'Ankara Kentpark AVM',
    slug: 'ankara-kentpark-avm',
    location: 'Ankara',
    category: 'AVM',
    image: 'https://static.wixstatic.com/media/eeca94_e06f06a5d3e74c3997dfdd702bbaeee0~mv2.jpg/v1/fill/w_1100,h_750,al_c,q_85,enc_avif,quality_auto/ankarakentpark4-2-1024x576.jpg',
    year: 2018,
    material: 'PVC Membran',
    form: 'Kubbe',
    areaM2: 3000,
    application: 'Park ve Rekreasyon',
  },
  {
    title: 'Kayseri Pazaryeri',
    slug: 'kayseri-pazaryeri',
    location: 'Kayseri',
    category: 'Pazar Yeri',
    image: 'https://static.wixstatic.com/media/eeca94_43d444b6c50b4bbb9af454e770b9d985~mv2.jpg/v1/fill/w_1100,h_750,al_c,q_85,enc_avif,quality_auto/Ana-resim-kayseri.jpg',
    year: 2013,
    material: 'PVC Membran',
    form: 'Kemerli',
    areaM2: 3000,
    application: 'Pazar Yeri',
  },
  {
    title: 'Fethiye Basketbol Sahası',
    slug: 'fethiye-basketbol-sahasi',
    location: 'Muğla',
    category: 'Spor',
    image: 'https://static.wixstatic.com/media/eeca94_c0740f816a824ded8676b4453e03a793~mv2.jpeg/v1/fill/w_1100,h_750,al_c,q_85,enc_avif,quality_auto/WhatsApp-Image-2019-03-08-at-15.21.47-1.jpeg',
    year: 2018,
    material: 'PVC Membran',
    form: 'Kubbe',
    areaM2: 2400,
    application: 'Basketbol sahası Kapma',
  },
  {
    title: 'Ankara Golf Arabası Park Alanı',
    slug: 'ankara-golf-arabasi-park-alani',
    location: 'Ankara',
    category: 'Otopark',
    image: 'https://static.wixstatic.com/media/eeca94_575b7381ffe24faa97472de0a50782a6~mv2.jpg/v1/fill/w_1100,h_750,al_c,q_85,enc_avif,quality_auto/ana-resim-ankara-golf.jpg',
    year: 2018,
    material: 'PVC Membran',
    form: 'Kemerli',
    areaM2: 2200,
    application: 'Golf Otopark Alanı',
  },
  {
    title: 'Erzincan Elite Koleji Okul',
    slug: 'erzincan-elite-koleji-okul',
    location: 'Erzincan',
    category: 'Egitim',
    image: 'https://static.wixstatic.com/media/eeca94_018191d55d2c474e9e2be954b7f3dab8~mv2.jpg/v1/fill/w_1100,h_750,al_c,q_85,enc_avif,quality_auto/ana-resim-600M2-1.jpg',
    year: 2018,
    material: 'PVC Membran',
    form: 'Kubbe',
    areaM2: 2000,
    application: 'Park ve Koleji',
  },
  {
    title: 'Kütahya Dumlupınar Üniversitesi',
    slug: 'kutahya-dumlupinar-universitesi',
    location: 'Kütahya',
    category: 'Egitim',
    image: 'https://static.wixstatic.com/media/eeca94_279bfd4ce9394b479e94c463da64027e~mv2.jpeg/v1/fill/w_1100,h_750,al_c,q_85,enc_avif,quality_auto/3-1024x768.jpeg',
    year: 2020,
    material: 'PVC Membran',
    form: 'Düz',
    areaM2: 2000,
    application: 'Depo Ünversite Tesisi',
  },
  {
    title: 'Çanakkale Biga Stadyum',
    slug: 'canakkale-biga-stadyum',
    location: 'Çanakkale',
    category: 'Stadyum',
    image: 'https://static.wixstatic.com/media/eeca94_820c527758c048b383fa31f98ba8f1be~mv2.jpeg/v1/fill/w_1100,h_750,al_c,q_85,enc_avif,quality_auto/WhatsApp-Image-2022-03-07-at-16.25.34-1024x461.jpeg',
    year: 2022,
    material: 'PVC Membran',
    form: 'Stadyum Kapma',
    areaM2: 2000,
    application: 'Stadyum Kapama',
  },
  {
    title: 'Ankara Polatlı',
    slug: 'ankara-polatli',
    location: 'Ankara',
    category: 'Park',
    image: 'https://static.wixstatic.com/media/eeca94_df8d8b538758428585edb00ad76ad9e6~mv2.jpeg/v1/fill/w_1100,h_750,al_c,q_85,enc_avif,quality_auto/WhatsApp-Image-2019-03-08-at-15.24.10-2-1024x768.jpeg',
    year: 2018,
    material: 'PVC Membran',
    form: 'Kubbe',
    areaM2: 2000,
    application: 'Park ve Dğün Alanı',
  },
  {
    title: 'Erzurum Uzundere Güreş Sahası',
    slug: 'erzurum-uzundere-gures-sahasi',
    location: 'Erzurum',
    category: 'Stadyum',
    image: 'https://static.wixstatic.com/media/eeca94_7982b7ec3dbe45709dc2946066b1fcb8~mv2.jpg/v1/fill/w_1100,h_750,al_c,q_85,enc_avif,quality_auto/3-4-1024x768.jpg',
    year: 2018,
    material: 'PVC Membran',
    form: 'düz',
    areaM2: 2000,
    application: 'Stadyum Kapama',
  },
  {
    title: 'İzmit/Ceyyıl Mega Ters Şemsiyesi',
    slug: 'izmit-ceyyil-mega-ters-semsiyesi',
    location: 'izmit',
    category: 'Ozel Yapi',
    image: 'https://static.wixstatic.com/media/eeca94_a0bc95c201ae43a3815b680483825701~mv2.jpeg/v1/fill/w_1100,h_750,al_c,q_85,enc_avif,quality_auto/WhatsApp-Image-2020-11-07-at-17.00.01-1024x576.jpeg',
    year: 2020,
    material: 'PVC Membran',
    form: 'Ters Şemsiye',
    areaM2: 1800,
    application: 'Ceyyıl Mega',
  },
  {
    title: 'Samsun',
    slug: 'samsun',
    location: 'Samsun',
    category: 'Park',
    image: 'https://static.wixstatic.com/media/eeca94_1f019533507c4ad4b97bb35fdbf99592~mv2.jpg/v1/fill/w_1100,h_750,al_c,q_85,enc_avif,quality_auto/sams%25C4%25B1nn%2520%281%29.jpg',
    year: 2018,
    material: 'PVC Membran',
    form: 'Kubbe',
    areaM2: 1600,
    application: 'Park ve Rekreasyon',
  },
  {
    title: 'Erzincan Elite Koleji 2',
    slug: 'erzincan-elite-koleji-2',
    location: 'Erzincan',
    category: 'Egitim',
    image: 'https://static.wixstatic.com/media/eeca94_da79730ddaf34e11a5264c3d0ce9c873~mv2.jpg/v1/fill/w_1100,h_750,al_c,q_85,enc_avif,quality_auto/Resim9.jpg',
    year: 2018,
    material: 'PVC Membran',
    form: 'Kubbe',
    areaM2: 1500,
    application: 'Park ve Koleji',
  },
  {
    title: 'Ankara Trafik Eğitim Parkı',
    slug: 'ankara-trafik-egitim-parki',
    location: 'Ankara',
    category: 'Park',
    image: 'https://static.wixstatic.com/media/eeca94_764b25cff2d94702b5e962ac62b361f7~mv2.jpeg/v1/fill/w_1100,h_750,al_c,q_85,enc_avif,quality_auto/WhatsApp-Image-2020-10-10-at-11.54.04-1024x768%2520%281%29.jpeg',
    year: 2020,
    material: 'PVC Membran',
    form: 'Yelken',
    areaM2: 1200,
    application: 'Trafik Eğitim alanı',
  },
  {
    title: 'Aksaray Üniversitesi',
    slug: 'aksaray-universitesi',
    location: 'Aksaray',
    category: 'Egitim',
    image: 'https://static.wixstatic.com/media/eeca94_32007a7d06b54190b30827b6415769f2~mv2.png/v1/fill/w_1100,h_750,al_c,q_85,enc_avif,quality_auto/WhatsApp-Image-2020-07-01-at-10.44.18.jpeg.png',
    year: 2020,
    material: 'PVC Membran',
    form: 'Yelken',
    areaM2: 1000,
    application: 'Ünversite Meydan',
  },
  {
    title: 'Pendik Esenyalı Pazar Yeri',
    slug: 'pendik-esenyali-pazar-yeri',
    location: 'Pendik',
    category: 'Pazar Yeri',
    image: 'https://static.wixstatic.com/media/eeca94_f026c142fd024e298d9edf9479507030~mv2.jpeg/v1/fill/w_1100,h_750,al_c,q_85,enc_avif,quality_auto/6.jpeg',
    year: 2022,
    material: 'PVC Membran',
    form: 'Kemerli',
    areaM2: 1000,
    application: 'Pazar Yeri',
  },
  {
    title: 'Marmaris Sahil Açılır Kapanır Asma germe',
    slug: 'marmaris-sahil-acilir-kapanir-asma-germe',
    location: 'Marmaris Muğla',
    category: 'Park',
    image: 'https://static.wixstatic.com/media/eeca94_ee23a37d6d2542dab9c0aa3e91dfa88f~mv2.jpg/v1/fill/w_1100,h_750,al_c,q_85,enc_avif,quality_auto/IMG-20240709-WA0005.jpg',
    year: 2024,
    material: 'PVC Membran',
    form: 'Açılır Kapanır',
    areaM2: 1000,
    application: 'Park Sahil Yolu',
  },
  {
    title: 'Çankırı Alpin Çorap Fabrikası',
    slug: 'cankiri-alpin-corap-fabrikasi',
    location: 'Çankırı',
    category: 'Fabrika',
    image: 'https://static.wixstatic.com/media/eeca94_1a27eaf35f3e42ccb09714398d4d4860~mv2.jpeg/v1/fill/w_1100,h_750,al_c,q_85,enc_avif,quality_auto/WhatsApp-Image-2021-03-06-at-12.15.43-1024x575.jpeg',
    year: 2021,
    material: 'PVC Membran',
    form: 'Yelken',
    areaM2: 900,
    application: 'Park ve Rekreasyon',
  },
  {
    title: 'Coante mermer fabrika deposu',
    slug: 'coante-mermer-fabrika-deposu',
    location: 'Muğla',
    category: 'Fabrika',
    image: 'https://static.wixstatic.com/media/eeca94_0125e4da6a8c494da5041e24cfe44c24~mv2.jpg/v1/fill/w_1100,h_750,al_c,q_85,enc_avif,quality_auto/IMG-20241016-WA0005.jpg',
    year: 2024,
    material: 'PVC',
    form: 'Depo Çadır',
    areaM2: 800,
    application: 'Fabrika',
  },
  {
    title: 'Adana İmamoğlu Millet Bahçesi',
    slug: 'adana-imamoglu-millet-bahcesi',
    location: 'Adana',
    category: 'Park',
    image: 'https://static.wixstatic.com/media/eeca94_95784d8011884d89820ec21bbaccb9c3~mv2.jpg/v1/fill/w_1100,h_750,al_c,q_85,enc_avif,quality_auto/WhatsApp%2520Image%25202023-04-05%2520at%252008.34.19.jpg',
    year: 2022,
    material: 'PVC Membran',
    form: 'Kubbe',
    areaM2: 800,
    application: 'Park(Milet Bahçesi)',
  },
  {
    title: 'TORIUM AVM',
    slug: 'torium-avm',
    location: 'Beylikdüzü',
    category: 'AVM',
    image: 'https://static.wixstatic.com/media/eeca94_c1045e80e3584527a183544dd6de7f98~mv2.jpeg/v1/fill/w_1100,h_750,al_c,q_85,enc_avif,quality_auto/WhatsApp-Image-2020-07-25-at-18.45.42.jpeg',
    year: 2020,
    material: 'PVC Membran',
    form: 'Yelken',
    areaM2: 700,
    application: 'AVM',
  },
  {
    title: 'İstanbul Tekno Park',
    slug: 'istanbul-tekno-park',
    location: 'Pendik',
    category: 'Park',
    image: 'https://static.wixstatic.com/media/eeca94_bc8110ec9a2649b3aacffca25d6556ca~mv2.jpeg/v1/fill/w_1100,h_750,al_c,q_85,enc_avif,quality_auto/WhatsApp-Image-2020-08-13-at-17.52.46-1024x512.jpeg',
    year: 2021,
    material: 'PVC Membran',
    form: 'kubbe',
    areaM2: 700,
    application: 'Park ve Rekreasyon',
  },
  {
    title: 'Çankırı Alpin Çorap',
    slug: 'cankiri-alpin-corap',
    location: 'Çankırı',
    category: 'Otopark',
    image: 'https://static.wixstatic.com/media/eeca94_93709adc5a1a46288df8b2672b2e15aa~mv2.jpeg/v1/fill/w_1100,h_750,al_c,q_85,enc_avif,quality_auto/WhatsApp-Image-2022-03-16-at-18.52.20-1.jpeg',
    year: 2021,
    material: 'PVC Membran',
    form: 'Kemerli',
    areaM2: 700,
    application: 'Otopark Kapma',
  },
  {
    title: 'Çanakkale Köprüsü',
    slug: 'canakkale-koprusu',
    location: 'Çanakkale',
    category: 'Otopark',
    image: 'https://static.wixstatic.com/media/eeca94_d62d5c6ea8b24bc690fd49547cff6469~mv2.jpg/v1/fill/w_1100,h_750,al_c,q_85,enc_avif,quality_auto/Ana-Resim-1000M2-1-1024x768.jpg',
    year: 2020,
    material: 'PVC Membran',
    form: 'Kemerli',
    areaM2: 700,
    application: 'Otopark Kapama',
  },
  {
    title: 'İzmir Ters Şemsiye',
    slug: 'izmir-ters-semsiye',
    location: 'İzmir',
    category: 'Park',
    image: 'https://static.wixstatic.com/media/eeca94_8512019b30354a2e8f400bf64e6c78b2~mv2.jpeg/v1/fill/w_1100,h_750,al_c,q_85,enc_avif,quality_auto/WhatsApp-Image-2020-08-19-at-18.00.41.jpeg',
    year: 2020,
    material: 'PVC Membran',
    form: 'Ters Şemsiye',
    areaM2: 600,
    application: 'Park ve Rekreasyon',
  },
  {
    title: 'Gaziantep Celal Doğan Parkı',
    slug: 'gaziantep-celal-dogan-parki',
    location: 'Gaziantep',
    category: 'Park',
    image: 'https://static.wixstatic.com/media/eeca94_4605bc2a7b7648edb96ba31bd5ee3959~mv2.jpg/v1/fill/w_1100,h_750,al_c,q_85,enc_avif,quality_auto/WhatsApp-Image-2020-11-16-at-14.23.31-1-1024x768.jpg',
    year: 2020,
    material: 'PVC Membran',
    form: 'Yelken',
    areaM2: 600,
    application: 'Park ve Rekreasyon',
  },
  {
    title: 'Yalova-Şehitlik',
    slug: 'yalova-sehitlik',
    location: 'Yolva',
    category: 'Park',
    image: 'https://static.wixstatic.com/media/eeca94_b116412fe67342f8af2e972fa5df2340~mv2.jpeg/v1/fill/w_1100,h_750,al_c,q_85,enc_avif,quality_auto/WhatsApp-Image-2020-08-05-at-16.22.10-512x1024%2520%281%29.jpeg',
    year: 2020,
    material: 'PVC Membran',
    form: 'Yelken',
    areaM2: 500,
    application: 'Park ve Rekreasyon',
  },
  {
    title: 'Kırklareli Valilik Parkı',
    slug: 'kirklareli-valilik-parki',
    location: 'Kırıkkale',
    category: 'Park',
    image: 'https://static.wixstatic.com/media/eeca94_7112d3c19ffb443a83613f7fad656734~mv2.jpg/v1/fill/w_1100,h_750,al_c,q_85,enc_avif,quality_auto/Resim78-1.jpg',
    year: 2017,
    material: 'PVC Membran',
    form: 'yelken',
    areaM2: 500,
    application: 'Park Milet Bahçesi',
  },
  {
    title: 'Nema Winkelmann Fabrika',
    slug: 'nema-winkelmann-fabrika',
    location: 'Düzce',
    category: 'Fabrika',
    image: 'https://static.wixstatic.com/media/eeca94_fa11a6d9ceed4641b5ef2a709c0e6916~mv2.jpg/v1/fill/w_1100,h_750,al_c,q_85,enc_avif,quality_auto/IMG-20240124-WA0085%2520%281%29.jpg',
    year: 2024,
    material: 'PVC Membran',
    form: 'Kubbe',
    areaM2: 500,
    application: 'Park ve Rekreasyon',
  },
  {
    title: 'Şişli Marriott Otel',
    slug: 'sisli-marriott-otel',
    location: 'Şişli',
    category: 'Otel',
    image: 'https://static.wixstatic.com/media/eeca94_292bda252450477787a6ae83c377a3ad~mv2.jpg/v1/fill/w_1100,h_750,al_c,q_85,enc_avif,quality_auto/Ana-Resim-10-1024x768.jpg',
    year: 2018,
    material: 'PVC Membran',
    form: 'yelken',
    areaM2: 500,
    application: 'Park ve Rekreasyon',
  },
  {
    title: 'Ankara Spor Bakanlığı Bahçesi',
    slug: 'ankara-spor-bakanligi-bahcesi',
    location: 'Ankara',
    category: 'Park',
    image: 'https://static.wixstatic.com/media/eeca94_a5296faa697f4eca96a127ff85983fc1~mv2.jpeg/v1/fill/w_1100,h_750,al_c,q_85,enc_avif,quality_auto/7.jpeg',
    year: 2021,
    material: 'PVC Membran',
    form: 'Yelken',
    areaM2: 500,
    application: 'Park ve Meydan',
  },
  {
    title: 'Türkiye’nin ilk 30m planateryumu',
    slug: 'turkiyenin-ilk-30m-planateryumu',
    location: 'BATMAN',
    category: 'Park',
    image: 'https://static.wixstatic.com/media/eeca94_b2054e86cb104171b6fe734a1112f9d5~mv2.jpg/v1/fill/w_1100,h_750,al_c,q_85,enc_avif,quality_auto/IMG-20250625-WA0005.jpg',
    year: 2025,
    material: 'PVC Membran',
    form: 'dome çadır kıralama',
    areaM2: 500,
    application: 'Park-Beyaz Köy Projesi',
  },
  {
    title: 'Muş Parkı',
    slug: 'mus-parki',
    location: 'Muş',
    category: 'Park',
    image: 'https://static.wixstatic.com/media/eeca94_8529a364a1cc4950a410522d107ba7c4~mv2.jpeg/v1/fill/w_1100,h_750,al_c,q_85,enc_avif,quality_auto/1.jpeg',
    year: 2020,
    material: 'PVC Membran',
    form: 'Kubbe',
    areaM2: 500,
    application: 'Park ve Rekreasyon',
  },
  {
    title: 'Bodrum Işıl Club Hotel',
    slug: 'bodrum-isil-club-hotel',
    location: 'Ankara',
    category: 'Otel',
    image: 'https://static.wixstatic.com/media/eeca94_d33471b4e79f4f808e64f2c40f10b1f9~mv2.jpeg/v1/fill/w_1100,h_750,al_c,q_85,enc_avif,quality_auto/WhatsApp-Image-2020-08-20-at-12.04.54-768x1024.jpeg',
    year: 2020,
    material: 'Mesh Membran',
    form: 'Düz Üçgen',
    areaM2: 450,
    application: 'Club Hotel',
  },
  {
    title: 'Yozgat Çocuk Trafik Parkı Eğitim Alanı',
    slug: 'yozgat-cocuk-trafik-parki-egitim-alani',
    location: 'Yozgat',
    category: 'Park',
    image: 'https://static.wixstatic.com/media/eeca94_713ef179566a40319f0afa4d492f128d~mv2.jpeg/v1/fill/w_1100,h_750,al_c,q_85,enc_avif,quality_auto/WhatsApp-Image-2021-10-02-at-16.32.03.jpeg',
    year: 2021,
    material: 'PVC Membran',
    form: 'Kemerli',
    areaM2: 400,
    application: 'Park ve Rekreasyon',
  },
  {
    title: 'Kızılıcahamam Millet Bahçesi',
    slug: 'kizilicahamam-millet-bahcesi',
    location: 'kızlıcaHamam',
    category: 'Park',
    image: 'https://static.wixstatic.com/media/eeca94_d3218fa84433470b941efca9f9c42e36~mv2.jpeg/v1/fill/w_1100,h_750,al_c,q_85,enc_avif,quality_auto/WhatsApp-Image-2021-12-07-at-19.21.31-1024x768%2520%281%29.jpeg',
    year: 2021,
    material: 'PVC Membran',
    form: 'Yelken',
    areaM2: 400,
    application: 'Park Milet Bahçesi',
  },
  {
    title: 'Sancaktepe Çocuk Park',
    slug: 'sancaktepe-cocuk-park',
    location: 'sancaktepe',
    category: 'Park',
    image: 'https://static.wixstatic.com/media/eeca94_6cdf95c69ff24ebfaaefa79c2b50bff3~mv2.jpg/v1/fill/w_1100,h_750,al_c,q_85,enc_avif,quality_auto/WhatsApp%2520Image%25202024-06-11%2520at%252013.43.59_796738a5.jpg',
    year: 2024,
    material: 'PVC Membran',
    form: 'Yelken',
    areaM2: 300,
    application: 'Park-Çocuk Parkı',
  },
  {
    title: 'İzmir Selçuk Emniyet Müdürlüğü',
    slug: 'izmir-selcuk-emniyet-mudurlugu',
    location: 'İzmir',
    category: 'Otopark',
    image: 'https://static.wixstatic.com/media/eeca94_8c238afdd61943e09bad315adb0d9b26~mv2.jpg/v1/fill/w_1100,h_750,al_c,q_85,enc_avif,quality_auto/izmiremniyet-1024x768.jpg',
    year: 2018,
    material: 'PVC Membran',
    form: 'Kemerli',
    areaM2: 300,
    application: 'Otopark Kapma',
  },
  {
    title: 'Nef Bahçelievler Siteleri',
    slug: 'nef-bahcelievler-siteleri',
    location: 'Bahçevler',
    category: 'Park',
    image: 'https://static.wixstatic.com/media/eeca94_70ef186d040f4b17b7abbf9ab7dffa3a~mv2.jpg/v1/fill/w_1100,h_750,al_c,q_85,enc_avif,quality_auto/e792474d-8a02-4db9-bd63-5f2075d75aa6-1024x576.jpg',
    year: 2021,
    material: 'PVC Membran',
    form: 'Yelken Şemsiye',
    areaM2: 300,
    application: 'Park ve Rekreasyon',
  },
  {
    title: 'Güngören Belediyesi',
    slug: 'gungoren-belediyesi',
    location: 'Güngören',
    category: 'Park',
    image: 'https://static.wixstatic.com/media/eeca94_31d202d52ecc4485901b8c7850ae9fb4~mv2.jpg/v1/fill/w_1100,h_750,al_c,q_85,enc_avif,quality_auto/Resim99.jpg',
    year: 2018,
    material: 'PVC Membran',
    form: 'Yelken',
    areaM2: 250,
    application: 'Park ve Rekreasyon',
  },
  {
    title: 'Gebze/Otopark',
    slug: 'gebze-otopark',
    location: 'Gebze',
    category: 'Otopark',
    image: 'https://static.wixstatic.com/media/eeca94_bc073fef33124e87b8b90532e720935b~mv2.jpeg/v1/fill/w_1100,h_750,al_c,q_85,enc_avif,quality_auto/WhatsApp-Image-2020-12-01-at-11.57.12-1.jpeg',
    year: 2021,
    material: 'PVC Membran',
    form: 'Kemerli',
    areaM2: 250,
    application: 'Otopark Kapama',
  },
  {
    title: 'Kozan Park Alanı',
    slug: 'kozan-park-alani',
    location: 'Adana',
    category: 'Park',
    image: 'https://static.wixstatic.com/media/eeca94_51c4a09c07704a85a8381484ddb4165b~mv2.jpeg/v1/fill/w_1100,h_750,al_c,q_85,enc_avif,quality_auto/WhatsApp-Image-2021-12-18-at-14.42.02-1024x576.jpeg',
    year: 2021,
    material: 'Mesh Membran',
    form: 'Şemsiye',
    areaM2: 200,
    application: 'Park Milet Bahçesi',
  },
  {
    title: 'Ordu Otopark',
    slug: 'ordu-otopark',
    location: 'Ordu',
    category: 'Otopark',
    image: 'https://static.wixstatic.com/media/eeca94_6677c848b02144b68feee14910fd6b79~mv2.jpg/v1/fill/w_1100,h_750,al_c,q_85,enc_avif,quality_auto/ana-resim-ordu-otopark.jpg',
    year: 2018,
    material: 'PVC Membran',
    form: 'Kemerli',
    areaM2: 200,
    application: 'Otopark Kapama',
  },
  {
    title: 'Toskana Vadisi',
    slug: 'toskana-vadisi',
    location: 'İstanbul',
    category: 'Park',
    image: 'https://static.wixstatic.com/media/eeca94_18bd1952084f452b97a160d88a900e9d~mv2.jpeg/v1/fill/w_1100,h_750,al_c,q_85,enc_avif,quality_auto/WhatsApp-Image-2020-08-19-at-18.00.13-2.jpeg',
    year: 2020,
    material: 'PVC Membran',
    form: 'Yelken',
    areaM2: 200,
    application: 'Park ve Rekreasyon',
  },
  {
    title: 'Ankara Spor Bakanlığı Bahçesi 2',
    slug: 'ankara-spor-bakanligi-bahcesi-2',
    location: 'Ankara',
    category: 'Park',
    image: 'https://static.wixstatic.com/media/eeca94_8a0f6de4b31d4ad492c3aae3ce303109~mv2.jpg/v1/fill/w_1100,h_750,al_c,q_85,enc_avif,quality_auto/membratek-1.jpg',
    year: 2021,
    material: 'PVC Membran',
    form: 'Yelken',
    areaM2: 200,
    application: 'Park ve Rekreasyon',
  },
  {
    title: 'Yeditepe Üniversitesi',
    slug: 'yeditepe-universitesi',
    location: 'İstanbul',
    category: 'Egitim',
    image: 'https://static.wixstatic.com/media/eeca94_72a58f1fdd9a4dd3afae6f9ad0d2503b~mv2.jpeg/v1/fill/w_1100,h_750,al_c,q_85,enc_avif,quality_auto/WhatsApp-Image-2019-08-28-at-12.19.50-768x1024%2520%281%29.jpeg',
    year: 2019,
    material: 'Mesh Membran',
    form: 'Yelken',
    areaM2: 200,
    application: 'Üniverste',
  },
];

// All CSV data is authoritative — only image gets upscaled
export const projects = _rawProjects.map((p) => ({
  ...p,
  image: W(p.image, 1400, 950),
}));
export const contactInfo = {
  address: '2. Organize Sanayi Bolgesi, Celal Dogan Bulvari No:30, Sehitkamil, Gaziantep',
  phone: '+90 532 711 98 27',
  emails: ['info@membratek.com', 'membratekproje@gmail.com'],
};
